import styles from './SbRespTradeOnApprovalLoadingBanner.module.css';

export const SbRespTradeOnApprovalLoadingBanner = () => <div className={styles.loadingBanner} />;
